var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "orderDetail" }, [
    _c("div", { staticClass: "banxin" }, [
      _c(
        "div",
        { staticClass: "head" },
        [
          _c("router-link", { attrs: { to: "/orderAfterSale" } }, [
            _c("div", { staticClass: "mar-right-10" }, [_vm._v("售后订单")])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "arrow" }),
          _vm._v(" "),
          _vm.state === "2"
            ? _c("div", { staticClass: "mar-right-10" }, [_vm._v("售后详情")])
            : _vm._e(),
          _vm._v(" "),
          _vm.state === "1"
            ? _c("div", { staticClass: "mar-right-10" }, [_vm._v("申请售后")])
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "status" }, [
        _c("div", { staticClass: "left" }, [
          _vm.state === "2"
            ? _c("p", { staticClass: "fs16 fw-blod mar-top-20 mar-bot-60" }, [
                _vm._v("售后编号：" + _vm._s(_vm.orderData.afterFormid))
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.state === "1"
            ? _c("p", { staticClass: "fs16 fw-blod mar-top-20 mar-bot-60" }, [
                _vm._v("订单号：" + _vm._s(_vm.orderData.orderFormid))
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "state text-align" },
            [
              _vm.state === "1"
                ? _c("p", { staticClass: "fs24 fw-blod font-color-FF7" }, [
                    _vm._v("申请售后")
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.orderData.afterState === 1
                ? _c("p", { staticClass: "fs24 fw-blod font-color-FF7" }, [
                    _vm._v("审核中")
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.orderData.afterState === 2
                ? _c("p", { staticClass: "fs24 fw-blod font-color-FF7" }, [
                    _vm._v("退款中")
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.orderData.afterState === 3
                ? _c("p", { staticClass: "fs24 fw-blod font-color-FF7" }, [
                    _vm._v("退货中")
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.orderData.afterState === 4
                ? _c("p", { staticClass: "fs24 fw-blod font-color-71B" }, [
                    _vm._v("退款成功")
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.orderData.afterState === 5
                ? _c("p", { staticClass: "fs24 fw-blod font-color-FF7" }, [
                    _vm._v("退款失败"),
                    _c("br"),
                    _c("span", { staticClass: "font-color-999" }, [
                      _vm._v("(如有问题，请联系商家)")
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.orderData.afterState === 6
                ? _c("p", { staticClass: "fs24 fw-blod font-color-FF7" }, [
                    _vm._v("审核不通过")
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.orderData.afterState === 7
                ? _c("p", { staticClass: "fs24 fw-blod font-color-FF7" }, [
                    _vm._v("评审中")
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.orderData.afterState === 8
                ? _c("p", { staticClass: "fs24 fw-blod font-color-999" }, [
                    _vm._v("退货完成，拒绝退款")
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.orderData.afterState === 9
                ? _c("p", { staticClass: "fs24 fw-blod font-color-999" }, [
                    _vm._v("已关闭")
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.orderData.afterState === 10
                ? _c("p", { staticClass: "fs24 fw-blod font-color-FF7" }, [
                    _vm._v("审核通过")
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.orderData.afterState === 6 || _vm.orderData.afterState === 8
                ? _c(
                    "el-button",
                    {
                      staticClass: "intervention mar-top-10",
                      attrs: { plain: "" },
                      on: { click: _vm.platform }
                    },
                    [_vm._v("申请平台介入")]
                  )
                : _vm._e(),
              _vm._v(" "),
              (_vm.orderData.afterState === 1 &&
                _vm.orderData.afterType === 1) ||
              (_vm.orderData.afterState === 6 &&
                _vm.orderData.afterType === 1) ||
              (_vm.orderData.afterState === 10 && _vm.orderData.afterType === 1)
                ? _c(
                    "el-button",
                    {
                      staticClass: "intervention mar-top-10",
                      attrs: { plain: "" },
                      on: { click: _vm.returnRefund }
                    },
                    [_vm._v("撤销申请")]
                  )
                : _vm._e(),
              _vm._v(" "),
              (_vm.orderData.afterState === 1 &&
                _vm.orderData.afterType === 2) ||
              (_vm.orderData.afterState === 6 && _vm.orderData.afterType === 2)
                ? _c(
                    "el-button",
                    {
                      staticClass: "intervention mar-top-10",
                      attrs: { plain: "" },
                      on: { click: _vm.returnGoods }
                    },
                    [_vm._v("撤销退货")]
                  )
                : _vm._e()
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "right" },
          [
            _vm.state === "1"
              ? _c("AfterSaleState", { attrs: { state: "" } })
              : _c("AfterSaleState", {
                  attrs: { state: _vm.orderData.afterState }
                })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "desc" }, [
        _vm.state !== "1"
          ? _c("div", { staticClass: "returnAddress" }, [
              _c("p", { staticClass: "title" }, [_vm._v("退货地址")]),
              _vm._v(" "),
              _c("div", { staticClass: "info" }, [
                _c("p", [
                  _vm._v("退货地址：" + _vm._s(_vm.orderData.returnAdress))
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v("退货收件人：" + _vm._s(_vm.orderData.returnPerson))
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "退货收件人联系电话：" + _vm._s(_vm.orderData.returnPhone)
                  )
                ])
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "storeInfo" }, [
          _c("p", { staticClass: "title" }, [_vm._v("卖家信息")]),
          _vm._v(" "),
          _c("div", { staticClass: "info" }, [
            _c("p", [_vm._v("店铺名称：" + _vm._s(_vm.orderData.shopName))]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "联系电话：" +
                  _vm._s(
                    _vm.orderData.chargePersonPhone || _vm.orderData.shopPhone
                  )
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "orderInfo" }, [
          _c("p", { staticClass: "title" }, [_vm._v("订单信息")]),
          _vm._v(" "),
          _c("div", { staticClass: "info" }, [
            _c("p", [_vm._v("订单号：" + _vm._s(_vm.orderData.orderFormid))]),
            _vm._v(" "),
            _c("p", [_vm._v("支付渠道：" + _vm._s(_vm.orderData.paymentMode))]),
            _vm._v(" "),
            _c("p", [_vm._v("交易号：" + _vm._s(_vm.orderData.transactionId))]),
            _vm._v(" "),
            _c("p", [_vm._v("创建时间：" + _vm._s(_vm.orderData.createTime))]),
            _vm._v(" "),
            _c("p", [_vm._v("付款时间：" + _vm._s(_vm.orderData.paymentTime))]),
            _vm._v(" "),
            _vm.orderData.receiveTime
              ? _c("p", [
                  _vm._v("成交时间：" + _vm._s(_vm.orderData.receiveTime))
                ])
              : _vm._e()
          ])
        ]),
        _vm._v(" "),
        _vm.state !== "1"
          ? _c("div", { staticClass: "afterSaleInfo" }, [
              _c("p", { staticClass: "title" }, [_vm._v("售后信息")]),
              _vm._v(" "),
              _c("div", { staticClass: "info" }, [
                _c("p", [
                  _vm._v(
                    "售后方式：" +
                      _vm._s(
                        _vm.orderData.afterType == 1 ? "仅退款" : "退货退款"
                      )
                  )
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "货物状态：" +
                      _vm._s(
                        _vm.orderData.goodsState == 0 ? "未收到货" : "已收到货"
                      )
                  )
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v("售后理由：" + _vm._s(_vm.orderData.returnReason))
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "long" }, [
                  _vm._v("退货理由描述：" + _vm._s(_vm.orderData.explain))
                ]),
                _vm._v(" "),
                _vm.orderData.image
                  ? _c(
                      "div",
                      { staticClass: "pic" },
                      [
                        _c("span", [_vm._v("凭证：")]),
                        _vm._v(" "),
                        _vm._l(_vm.image, function(url, ins) {
                          return _c("el-image", {
                            key: ins,
                            staticStyle: { width: "100px", height: "100px" },
                            attrs: { src: url, "preview-src-list": _vm.image }
                          })
                        })
                      ],
                      2
                    )
                  : _vm._e()
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "productInfo" },
          [
            _vm._m(0),
            _vm._v(" "),
            _vm._l(_vm.orderData.skus, function(pro, idx) {
              return _c("div", { key: idx, staticClass: "bottom" }, [
                _c("div", { staticClass: "big" }, [
                  _c("img", { attrs: { src: pro.image, alt: "" } }),
                  _vm._v(" "),
                  _c("p", [_vm._v(_vm._s(pro.productName))])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticStyle: { "flex-direction": "column" } },
                  _vm._l(pro.values, function(text, ins) {
                    return _c("p", { key: ins }, [_vm._v(_vm._s(text))])
                  }),
                  0
                ),
                _vm._v(" "),
                _vm.orderData.state == 1 || _vm.orderData.orderState == 1
                  ? _c("div", [_vm._v("待付款")])
                  : _vm._e(),
                _vm._v(" "),
                _vm.orderData.state == 2 || _vm.orderData.orderState == 2
                  ? _c("div", [_vm._v("待发货")])
                  : _vm._e(),
                _vm._v(" "),
                _vm.orderData.state == 3 || _vm.orderData.orderState == 3
                  ? _c("div", [_vm._v("待收货")])
                  : _vm._e(),
                _vm._v(" "),
                _vm.orderData.state == 4 || _vm.orderData.orderState == 4
                  ? _c("div", [_vm._v("已完成")])
                  : _vm._e(),
                _vm._v(" "),
                _vm.orderData.state == 5 || _vm.orderData.orderState == 5
                  ? _c("div", [_vm._v("已关闭")])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", [_vm._v(_vm._s(pro.number))]),
                _vm._v(" "),
                _c("div", { staticClass: "font-color-FF7 fs-bold" }, [
                  _vm._v("¥" + _vm._s(pro.price))
                ])
              ])
            })
          ],
          2
        ),
        _vm._v(" "),
        _vm.orderData.afterState === 4
          ? _c("div", { staticClass: "returnPrice" }, [
              _c("div", [
                _c("span", { staticClass: "mar-right-40" }, [
                  _vm._v("退款金额：")
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "font-color-FF7" }, [
                  _vm._v("¥" + _vm._s(_vm.orderData.price))
                ])
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.state === "1"
          ? _c("div", { staticClass: "apply" }, [
              _c(
                "div",
                { staticClass: "flex-display mar-bot-10" },
                [
                  _vm._m(1),
                  _vm._v(" "),
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择售后方式" },
                      model: {
                        value: _vm.mode,
                        callback: function($$v) {
                          _vm.mode = $$v
                        },
                        expression: "mode"
                      }
                    },
                    _vm._l(_vm.modes, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "flex-display mar-bot-10" },
                [
                  _vm._m(2),
                  _vm._v(" "),
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择货物状态" },
                      model: {
                        value: _vm.goodsState,
                        callback: function($$v) {
                          _vm.goodsState = $$v
                        },
                        expression: "goodsState"
                      }
                    },
                    _vm._l(_vm.goodsStatus, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "flex-display mar-bot-10" },
                [
                  _vm._m(3),
                  _vm._v(" "),
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择售后理由" },
                      model: {
                        value: _vm.reason,
                        callback: function($$v) {
                          _vm.reason = $$v
                        },
                        expression: "reason"
                      }
                    },
                    _vm._l(_vm.reasons, function(item) {
                      return _c("el-option", {
                        key: item,
                        attrs: { label: item, value: item }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "flex-display mar-bot-10" },
                [
                  _c("div", { staticClass: "mar-right-30 mar-left-10" }, [
                    _vm._v("原因描述：")
                  ]),
                  _vm._v(" "),
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 6,
                      placeholder: "输入申请退货原因描述"
                    },
                    model: {
                      value: _vm.textarea,
                      callback: function($$v) {
                        _vm.textarea = $$v
                      },
                      expression: "textarea"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "flex-display mar-bot-10" },
                [
                  _c("div", { staticClass: "mar-right-30 mar-left-10" }, [
                    _vm._v("上传凭证：")
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-upload",
                    {
                      attrs: {
                        action: _vm.action,
                        "list-type": "picture-card",
                        limit: 5,
                        "on-success": _vm.handleSuccess,
                        "on-remove": _vm.handleRemove
                      }
                    },
                    [_c("i", { staticClass: "el-icon-plus" })]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "submit mar-20" },
                [
                  _c(
                    "el-button",
                    {
                      directives: [{ name: "throttle", rawName: "v-throttle" }],
                      attrs: { plain: "" },
                      on: { click: _vm.submit }
                    },
                    [_vm._v("提交申请")]
                  )
                ],
                1
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.orderData.afterState === 10
          ? _c("div", { staticClass: "express" }, [
              _c(
                "div",
                { staticClass: "flex-display mar-bot-10" },
                [
                  _vm._m(4),
                  _vm._v(" "),
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择物流公司" },
                      model: {
                        value: _vm.exp,
                        callback: function($$v) {
                          _vm.exp = $$v
                        },
                        expression: "exp"
                      }
                    },
                    _vm._l(_vm.express, function(item) {
                      return _c("el-option", {
                        key: item.dictId,
                        attrs: { label: item.dictName, value: item.dictId }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "flex-display mar-bot-10" },
                [
                  _vm._m(5),
                  _vm._v(" "),
                  _c("el-input", {
                    staticStyle: { width: "30%", "margin-bottom": "20px" },
                    attrs: { type: "number", placeholder: "请填写物流单号" },
                    model: {
                      value: _vm.text,
                      callback: function($$v) {
                        _vm.text = $$v
                      },
                      expression: "text"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticStyle: { "text-align": "center" } },
                [
                  _c(
                    "el-button",
                    {
                      directives: [{ name: "throttle", rawName: "v-throttle" }],
                      attrs: { plain: "" },
                      on: { click: _vm.returnExpress }
                    },
                    [_vm._v("确认提交")]
                  )
                ],
                1
              )
            ])
          : _vm._e()
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "top" }, [
      _c("span", { staticClass: "big" }, [_vm._v("商品")]),
      _vm._v(" "),
      _c("span", [_vm._v("商品属性")]),
      _vm._v(" "),
      _c("span", [_vm._v("状态")]),
      _vm._v(" "),
      _c("span", [_vm._v("数量")]),
      _vm._v(" "),
      _c("span", [_vm._v("单价")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mar-right-30" }, [
      _c("span", { staticClass: "font-color-FF7" }, [_vm._v("✱")]),
      _vm._v("售后方式：")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mar-right-30" }, [
      _c("span", { staticClass: "font-color-FF7" }, [_vm._v("✱")]),
      _vm._v("货物状态：")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mar-right-30" }, [
      _c("span", { staticClass: "font-color-FF7" }, [_vm._v("✱")]),
      _vm._v("售后理由：")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mar-right-30" }, [
      _c("span", { staticClass: "font-color-FF7" }, [_vm._v("✱")]),
      _vm._v("物流公司：")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mar-right-30" }, [
      _c("span", { staticClass: "font-color-FF7" }, [_vm._v("✱")]),
      _vm._v("物流单号：")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-7a6a79dc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-7a6a79dc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/views/afterSale/index.vue
// module id = null
// module chunks = 